import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import { useRouter } from 'hooks/useRouter';

export const useFetchFingerprint = (documentName: string | null = null) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
  });

  const { query } = useRouter();

  const { teamId, folderId, documentId } = query;

  const fn = useQuery(
    ['fetch-fingerprint', teamId, folderId, documentId, documentName],
    async () => {
      const { data: blob } = await client.fetchDocumentFingerprint(
        teamId as string,
        folderId as string,
        documentId as string,
      );

      const a = window.document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = `Huella de auditoría - ${documentName} - CINCEL.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    {
      enabled: false,
    },
  );

  return { ...fn };
};
